import React from 'react';
import { Chip } from '../../styleguide';

export function displayErrors(errors) {
  return (
    <div>
      {
        errors.map(m => {
          if (typeof m === 'string') {
            return <div><p>{ m }</p></div>;
          } else {
            return (
              <div className='mult-errors'>
                {
                  m.map((err,i) => {
                    if (i === m.size - 1) {
                      return <p>{ err }</p>;
                    } else {
                      return <p>{`- ${err}`}</p>;
                    }
                  })
                }
              </div>
            );
          }
        })
      }
    </div>
  );
}


export function displayUSPrivacyErrors(regulation,errors) {
  console.log(errors)
  return (
    <>
      <div>{regulation?.name} cannot be activated due to the following reasons:</div>
      <div style={{border:'1px solid grey'}}>
        <div>CONFLICT: 46 property(s) are already present in an Active Regulation.</div>
        <div style={{background: "#F2F2F2",borderRadius: '6px'}}>
        Note: Property can only be mapped to one Active Regulation at a time.
        </div>
        <div style={{background: "#FFFFFF",border: '1px solid #DEDEDE',borderRadius: '6px'}}>
        <div><span>Regulation</span>{regulation?.name}</div>
        <div><span>Properties</span>{errors.map((err => {
            return(<Chip>{err}</Chip>)
        }))}</div>
        </div>
      </div>
    </>
  );
}